import React from "react";
import {
  Box,
  Typography,
  styled,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Mobile Avatar Selection Card
import MobileAvatarSelectionCard from "./MobileAvatarSelectionCard";

const MobileHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: '0.75rem 1rem',
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  position: 'sticky',
  top: 0,
  zIndex: 100,
}));

const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  flex: 1,
}));

// === Mobile Container ===
const MobileContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  display: "flex",
  flexDirection: "column",
}));

// === Content Wrapper ===
const ContentWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: '1rem',
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflowY: "auto",
}));

// === Mobile Title (optional - falls du den Titel im Content behalten möchtest) ===
const MobileTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: "1.5rem",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.25rem",
    marginBottom: "1rem",
  },
}));

// === Component ===
const MobileAvatarSettings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <MobileContainer>
      {/* Mobile Header */}
      <MobileHeader>
        <IconButton onClick={handleBack} size="small">
          <ArrowBackIcon />
        </IconButton>
        <HeaderTitle>{t("Avatar Selection")}</HeaderTitle>
      </MobileHeader>

      {/* Content */}
      <ContentWrapper>
        {/* Avatar Selection Card */}
        <Box sx={{ width: '100%', mt: 6}}>
          <MobileAvatarSelectionCard />
        </Box>
      </ContentWrapper>
    </MobileContainer>
  );
};

export default MobileAvatarSettings;